import { TypedDocumentNode, gql } from "@apollo/client";

import { Commit, PageInfo, QuerySearchRunsArgs, Run } from "types/generated";

export type StackTaskRun = Pick<
  Run,
  "id" | "command" | "createdAt" | "state" | "triggeredBy" | "type"
> & {
  commit: Pick<Commit, "hash" | "url">;
};

type SearchStackTasksData = {
  searchRuns: {
    edges: Array<{ node: { run: StackTaskRun } }>;
    pageInfo: PageInfo;
  };
};

export const SEARCH_STACK_TASKS: TypedDocumentNode<
  SearchStackTasksData,
  Pick<QuerySearchRunsArgs, "input">
> = gql`
  query SearchStackTasks($input: SearchInput!) {
    searchRuns(input: $input) {
      edges {
        node {
          run {
            id
            command
            commit {
              hash
              url
            }
            createdAt
            state
            triggeredBy
            type
          }
        }
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
